import { useRouter } from "next-translate-routes";
import { addQueryParamToUrl } from "@/utils/addQueryParamToUrl";
import { useReferrerUrl } from "@/hooks/useReferrerUrl";

export const useAuthUrls = (): {
  getLoginUrl: (referrerParams?: QueryParam[]) => string;
  getRegisterUrl: (referrerParams?: QueryParam[]) => string;
  getSubscriptionUrl: (referrerParams?: QueryParam[]) => string;
} => {
  const { getReferrerUrlWithParams } = useReferrerUrl();
  const router = useRouter();
  const { postOrPage } = router.query;
  /**
   * Add referrer query param to auth url
   */
  function buildUrlWithReferrer(url: string, referrerParams: QueryParam[] = []): string {
    if (postOrPage && postOrPage[0]) {
      referrerParams.push({ key: "article_id", value: postOrPage[0] });
    }

    const referrerUrl = getReferrerUrlWithParams(referrerParams);

    return addQueryParamToUrl(url, "referrer", referrerUrl);
  }

  function getLoginUrl(referrerParams?: QueryParam[]): string {
    return buildUrlWithReferrer(`${process.env.NEXT_PUBLIC_REMP_URL}/sign/in`, referrerParams);
  }

  function getRegisterUrl(referrerParams?: QueryParam[]): string {
    return buildUrlWithReferrer(`${process.env.NEXT_PUBLIC_REMP_URL}/sign/up`, referrerParams);
  }

  function getSubscriptionUrl(referrerParams?: QueryParam[]): string {
    return buildUrlWithReferrer(`${process.env.NEXT_PUBLIC_REMP_URL}/subscriptions`, referrerParams);
  }

  return { getLoginUrl, getRegisterUrl, getSubscriptionUrl };
};
